import Modal from './Modal';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';

type ModalCompound = {
  Header: typeof ModalHeader;
  Content: typeof ModalContent;
  Footer: typeof ModalFooter;
};

const _ModalCompound: any = Modal;
_ModalCompound.Header = ModalHeader;
_ModalCompound.Content = ModalContent;
_ModalCompound.Footer = ModalFooter;

export default _ModalCompound as ModalCompound & typeof Modal;
